export default function WhatIsSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
        <div>
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            Grundlagen
          </span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-4">
            Was ist ein OOPBuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            Ein <strong>OOPBuy Spreadsheet</strong> ist eine strukturierte Produktübersicht, mit der Nutzer interessante Produkte schneller finden, vergleichen und analysieren können. Es handelt sich um eine speziell aufbereitete Tabelle, die verschiedene Produktkategorien, Preisinformationen und Qualitätsbewertungen übersichtlich darstellt.
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
            Im Gegensatz zur klassischen Google-Suche oder dem Durchstöbern von Social Media bietet ein OOPBuy Spreadsheet eine deutlich bessere Übersicht und spart wertvolle Zeit bei der Produktrecherche. Besonders für Einsteiger ist diese Methode ideal, da alle wichtigen Informationen gebündelt und strukturiert vorliegen.
          </p>

          <div className="space-y-2">
            {[
              "Produktkategorien übersichtlich geordnet",
              "Preisvergleiche auf einen Blick",
              "Qualitätskontrollen und Bewertungen",
              "Detaillierte Produktinformationen",
              "Einfache und intuitive Nutzung",
            ].map((item) => (
              <div key={item} className="flex items-center gap-2 text-foreground-600 text-sm">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                </div>
                {item}
              </div>
            ))}
          </div>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 overflow-x-auto">
          <h3 className="font-heading text-foreground-900 text-lg mb-4">Vergleich der Suchmethoden</h3>
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-200/70">
                <th className="text-left py-3 pr-4 text-foreground-700 font-medium whitespace-nowrap">Methode</th>
                <th className="text-left py-3 pr-4 text-foreground-700 font-medium whitespace-nowrap">Geschwindigkeit</th>
                <th className="text-left py-3 pr-4 text-foreground-700 font-medium whitespace-nowrap">Übersicht</th>
                <th className="text-left py-3 text-foreground-700 font-medium whitespace-nowrap">Anfänger geeignet</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">Google Suche</td>
                <td className="py-3 pr-4 text-foreground-600 whitespace-nowrap">Mittel</td>
                <td className="py-3 pr-4 text-foreground-600 whitespace-nowrap">Niedrig</td>
                <td className="py-3 text-foreground-600 whitespace-nowrap">Ja</td>
              </tr>
              <tr className="border-b border-background-100">
                <td className="py-3 pr-4 text-foreground-700 whitespace-nowrap">Social Media</td>
                <td className="py-3 pr-4 text-foreground-600 whitespace-nowrap">Mittel</td>
                <td className="py-3 pr-4 text-foreground-600 whitespace-nowrap">Niedrig</td>
                <td className="py-3 text-foreground-600 whitespace-nowrap">Teilweise</td>
              </tr>
              <tr>
                <td className="py-3 pr-4 text-primary-600 font-semibold whitespace-nowrap">OOPBuy Spreadsheet</td>
                <td className="py-3 pr-4 text-primary-600 font-semibold whitespace-nowrap">Sehr schnell</td>
                <td className="py-3 pr-4 text-primary-600 font-semibold whitespace-nowrap">Sehr hoch</td>
                <td className="py-3 text-primary-600 font-semibold whitespace-nowrap">Ja</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}